export const API_AUTH = {
  LOGIN: "/authToken",
}

export const API_ACTIVITY = {
  ADD_ACTIVITY: "/useractivity/add",
  GET_ACTIVITY: "/useractivity/get"
}

export const API_SEARCH = {
  SEARCH: "/search",
  CSV_DOWNLOAD: "/search/csv",
  AUTOCOMPLETE: "/search/autocomplete",
  SUGGEST: "/search/suggest",
}

export const API_USER = {
  CHANGE_PASSWORD: "/user/changePassword",
  RESET_PASSWORD: "/user/resetPassword",
  SEARCHUSER: "/user/searchUser",
  GET_USERBYID: "/user/getUserById",
  ADD_USER: "/user/addUser",
  UPDATE_USER: "/user/updateUser",
  GET_ROLES: "/user/getRoles",
  ADD_ROLES: "/user/addRole",
  UPDATE_ROLES: "/user/updateRole",
  DELETE_ROLE: '/user/deleteRole',
  GET_PRIVILEGES: "/user/getPrivileges",
  ADD_PRIVILEGE: "/user/addPrivilege",
  UNLOCK_USER: "/user/unlockUser",
  UPDATE_STATUS: "/user/updateUserActiveInactive",
  UPDATE_ROLE: "/user/updateUserRole",
}
